import React from "react";
import {
  Button,
  Box,
  Typography,
} from '@mui/material';
import Icon from "components/icon";


export default function DetailButton(props) {
  const {
    iconId,
    title,
    description,
    sx,
    ...rest
  } = props;

  return (
    <Button
      fullWidth
      startIcon={<Icon type={iconId} />}
      sx={{
        px: 2,
        py: 1.5,
        mb: 2,
        justifyContent: 'flex-start',
        '& .MuiSvgIcon-root': {
          fontSize: 'sizes.7',
          mr: 1.5,
        },
        ...sx
      }}
      {...rest}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'left', }}>
        <Typography variant='subtitle1' sx={{ fontSize: 'sizes.2', }}>{title}</Typography>
        {description && <Typography variant='caption' sx={{ textTransform: 'none', fontSize: 'sizes.1', }}>{description}</Typography>}
      </Box>
    </Button>
  );
}